import React, { ReactNode } from "react";

export const Sidebar = ({
  isVisible,
  hideSidebarHandler,
  children,
}: {
  isVisible: boolean;
  hideSidebarHandler: () => void;
  children: ReactNode;
}) => (
  <div className={`sidebar ${isVisible ? "in" : ""}`}>
    <div className="sidebar-header pointer" onClick={hideSidebarHandler}>
      <a href="#" className="btn btn-xs btn-icon btn-light btn-hover-primary">
        <i className="ki ki-close icon-xs text-muted" />
      </a>
    </div>{" "}
    <div className="sidebar-body">{children}</div>
  </div>
);
